

















































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import BirthdaysProgramDetails from "./BirthdaysProgramDetails.vue";

import BirthdayProgramJson from "../../shared/BirthdayProgramJson";

import UserJson from "../../shared/UserJson";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "BirthdaysPrograms",
  components: {
    Loading,
    TableView,
    BirthdaysProgramDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      allUsers: null as UserJson[] | null,
      detailsMode: "read",
      allBirthdayPrograms: null as BirthdayProgramJson[] | null,
      selectedProgramId: null as number | null,
      selectedProgram: null as BirthdayProgramJson | null,
      loading: false,
    };
  },
  created() {
    this.$emit("resetAppFrameButtons");
    /* this.$emit("showAppFrameButtons", { reload: true }) */
    this.loadData();
  },
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadBirthdayPrograms();
    },

    async loadBirthdayPrograms() {
      this.allBirthdayPrograms = null;

      try {
        this.allBirthdayPrograms = await this.restClient.getBirthdayPrograms();
      } catch (e) {
        alert(e.message);
      }
    },

    //todo: viell. in Zukunft nur die einzelnen User laden
    async loadAllUsers() {
      try {
        this.allUsers = await this.restClient.getUsers();
      } catch (e) {
        alert(e.message);
      }
    },

    /*
    permissionAble: function(item: BirthdayBookingJson) {
      if (
        this.loginPermission > item.permissionRank ||
        this.loginPermission == this.UserPermissionRank.admin ||
        this.loginId == item.ID
      ) {
        return true
      } else {
        return false
      }
    },
*/

    getStaffFullName(staffId: number | null) {
      if (staffId != null) {
        if (this.allUsers != null) {
          let staff = this.allUsers.find((user) => user.ID == staffId);

          return staff?.firstName + " " + staff?.lastName;
        }
      } else {
        return "ohne Betreuer";
      }
    },

    openDetails(item: BirthdayProgramJson | null, mode: string) {
      if (item != null) {
        this.selectedProgramId = item.ID;
        this.selectedProgram = JSON.parse(JSON.stringify(item));
      } else {
        this.selectedProgramId = null;
        this.selectedProgram = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    programsColumns: function (): TableViewColumnDefinitions<BirthdayProgramJson>[] {
      let vue = this;

      return [
        {
          th: "Titel",
          td: (i) => i.title,
        },
        {
          th: "Kategorie",
          td: (i) => i.category,
        },
        {
          th: "Beschränkung der Betreuer:innen",
          td: (i) => (i.restrictStaffAssignmentIds ? "Ja" : "Nein"),
        },
        {
          th: "Abweichende Zeiten",
          td: (i) => (i.alternateTimeSlots ? "Ja" : "Nein"),
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<BirthdayProgramJson>[];
    },

    allUsedCategories(): string[] {
      let categories: string[] = [];

      if (this.allBirthdayPrograms != null) {
        categories = this.allBirthdayPrograms.map((i: BirthdayProgramJson) => i.category);
      }

      return [...new Set(categories)];
    },
  },
});
